import Link from "next/link";
import Icon from "../../../components/ui/AppIcon";

interface QuickAccessCardProps {
  item: {
    id: string;
    title: string;
    description: string;
    icon: string;
    href: string;
    color: string;
  };
}

const QuickAccessCard = ({ item }: QuickAccessCardProps) => {
  return (
    <Link data-component-id="src/app/homepage/components/QuickAccessCard.tsx:17:4" data-component-path="src/app/homepage/components/QuickAccessCard.tsx" data-component-line="17" data-component-end-line="37" data-component-file="QuickAccessCard.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22group%20bg-card%20rounded-xl%20p-6%20shadow-md%20hover%3Ashadow-warm%20transition-all%20duration-300%20transform%20hover%3Ascale-105%20border%20border-border%20hover%3Aborder-brand-primary%22%7D"
      href={item.href}
      className="group bg-card rounded-xl p-6 shadow-md hover:shadow-warm transition-all duration-300 transform hover:scale-105 border border-border hover:border-brand-primary"
    >
      <div data-component-id="src/app/homepage/components/QuickAccessCard.tsx:21:6" data-component-path="src/app/homepage/components/QuickAccessCard.tsx" data-component-line="21" data-component-end-line="30" data-component-file="QuickAccessCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`w-14 h-14 rounded-lg ${item.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}
      >
        <Icon data-component-id="src/app/homepage/components/QuickAccessCard.tsx:24:8" data-component-path="src/app/homepage/components/QuickAccessCard.tsx" data-component-line="24" data-component-end-line="29" data-component-file="QuickAccessCard.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D"
          name={item.icon as any}
          size={28}
          variant="outline"
          className="text-white"
        />
      </div>
      <h3 data-component-id="src/app/homepage/components/QuickAccessCard.tsx:31:6" data-component-path="src/app/homepage/components/QuickAccessCard.tsx" data-component-line="31" data-component-end-line="33" data-component-file="QuickAccessCard.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20font-semibold%20text-base%20text-foreground%20mb-2%20group-hover%3Atext-brand-primary%20transition-colors%22%7D" className="font-headline font-semibold text-base text-foreground mb-2 group-hover:text-brand-primary transition-colors">
        {item.title}
      </h3>
      <p data-component-id="src/app/homepage/components/QuickAccessCard.tsx:34:6" data-component-path="src/app/homepage/components/QuickAccessCard.tsx" data-component-line="34" data-component-end-line="36" data-component-file="QuickAccessCard.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-sm%20text-muted-foreground%20leading-relaxed%22%7D" className="font-body text-sm text-muted-foreground leading-relaxed">
        {item.description}
      </p>
    </Link>
  );
};

export default QuickAccessCard;
